import { Link, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { LoginServices } from '../../../services/login.service';
import { STORAGE } from '../../../constants';
import { LocalStorageService } from '../../../services/local-storage.service';
import { useTranslation } from 'react-i18next';
import BgBody from '../../../components/layout/bg-body.component';
import Input from '../../../components/forms/input.component';
import Button from '../../../components/forms/button.component';
import BgPages from '../../../hooks/use-bg-pages.hook';
import Icon from '../../../components/forms/icon.component';
import { LandingRouteService } from '../../../services/landing-route.service';

declare const KTComponents: any;

function AuthPage() {
  BgPages();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [errorMessage, seterrorMessage] = useState('');

  const {
    register,
    handleSubmit,
    formState: { errors, isValid, isSubmitting }
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      identifier: '',
      password: ''
    }
  });

  const handleAlertClose = () => {
    seterrorMessage('');
  };

  const login = async (data: any) => {
    const payload = {
      identifier: data.identifier,
      password: data.password
    };

    try {
      const response = await LoginServices.login(payload);
      LocalStorageService.save(STORAGE.SESSION, response);
      if (response?.accessToken) {
        LocalStorageService.save(STORAGE.TOKEN, response.accessToken);
      }
      if (response?.user?.roles) {
        LocalStorageService.save(STORAGE.ROLE_DATA, response.user.roles);
      }
      navigate(LandingRouteService.getHomeRoute());
    } catch (error: any) {
      console.error('Error original interceptado:', error);

      const serverMessage =
        error?.status ||
        error?.response?.data?.message ||
        error?.message ||
        'Error al iniciar sesión';

      seterrorMessage(String(serverMessage));
    }
  };

  useEffect(() => {
    const session = LocalStorageService.get(STORAGE.SESSION);
    const token = LocalStorageService.get(STORAGE.TOKEN);

    if (session && token) {
      navigate(LandingRouteService.getHomeRoute());
    }
  }, [navigate]);

  useEffect(() => {
    KTComponents.init();
  }, []);

  return (
    <>
      <BgBody />
      <div className="login-hero login-hero--auth text-white bg-p-dark">
        <div className="login-brand login-brand--auth hide-ipad d-flex flex-column align-items-start text-start">
          <div className="d-flex flex-column align-items-start lh-1 ms-4">
            <h1 className="brand-title fs-1 fs-md-3x text-white mb-0">
              {t('auth-Login.title-page')}
            </h1>
            <p className="brand-subtitle text-primary fw-bold mt-0 mb-0 fs-3">
              {t('auth-Login.subtitle-page')}
            </p>
          </div>
        </div>
        <div className="login-shell--auth d-flex justify-content-center px-2 px-sm-4 position-relative w-100">
          <div className="login-flat login-card--auth device-card device-card--glow shadow-xxl d-flex flex-column justify-content-between">
            <div className="text-center mb-md-15 mt-10">
              <img
                alt="Logo"
                src="/assets/media/logos/voices-gnl-dark.png"
                className="h-45px h-lg-155px logo-default mb-3 mb-md-5 logob z-index-4 img-fluid"
              />
              <h1 className="fs-2x fw-bold mb-1 text-white">{t('auth-Login.title')}</h1>
              <div className="text-gray-500 fs-6 fs-md-4">{t('auth-Login.subtitle')}</div>
            </div>

            {errorMessage && (
              <div className="alert alert-danger d-flex align-items-center p-2 bg-transparent animated-Alert mt-4 mb-5">
                <Icon icon="ki-shield-cross" size="fs-2hx" type="danger" className="me-4" />
                <div className="d-flex flex-column flex-grow-1">
                  <h4 className="mb-1 text-white">{t('errors.title-text-alert-atencion')}</h4>
                  <span>{errorMessage}</span>
                </div>
                <button
                  type="button"
                  className="btn btn-icon bg-transparent ms-auto"
                  onClick={handleAlertClose}
                >
                  <Icon icon="ki-cross" size="fs-1" type="white" />
                </button>
              </div>
            )}

            <form className="form mb-10" onSubmit={handleSubmit(login)}>
              <div className="mb-6 inputb">
                <Input
                  typeBg="text-white"
                  requiredIndicator="required"
                  uniqueTheme
                  label="Usuario o correo electrónico"
                  placeholder="Ingresa tu usuario o correo"
                  errors={errors.identifier}
                  {...register('identifier', { required: true, setValueAs: (v) => v.trim() })}
                />
              </div>

              <div className="mb-8 mb-md-16 inputb">
                <Input
                  typeBg="text-white"
                  requiredIndicator="required"
                  uniqueTheme
                  page="login"
                  label={t('forms.inputs.title-input-password')}
                  placeholder={t('forms.inputs.placeholder-input-password')}
                  type="password"
                  errors={errors.password}
                  {...register('password', { required: true })}
                />
              </div>

              <Button
                type="submit"
                className="btn btn-lg btn-primary w-100 mb-4"
                disabled={!isValid}
                isLoading={isSubmitting}
              >
                {t('forms.inputs.title-button-submit')}
              </Button>

              <div className="text-center">
                <Link to="/auth/forgot-password" className="link-primary fs-7 fw-semibold">
                  ¿Olvidaste tu contraseña?
                </Link>
              </div>
            </form>

            <div className="d-flex align-items-center justify-content-end mt-8 mt-md-25"></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AuthPage;
